import { Controller } from "stimulus"

export default class Job extends Controller {
  handleDeleteCv() {
    // event.currentTarget.dataset to get the params through data
    fetch(event.detail.url, {
      method: 'DELETE',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
      }
    })
    .then(response => response.json())
    .then(data => {
      toastr.success('Cv has been removed.')
    })
    .catch((error) => {
      toastr.error('Something went wrong')
    });
  }

  resetMessage() {
    this.element.reset()
  }
}
